module.exports = {
    ENABLE_RETAIL_LOAN_HIRE_IN_CC: __CONTACT_CENTER__,
};
